<template>
  <div>
    <div class="banshi">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="item in swiperList"
            :key="item.id"
            class="swiper-slide"
          >
            <img :src="item.url" alt="" />
          </div>
        </div>
        <div v-show="pagination" class="swiper-pagination"></div>
        <div v-show="navigation" class="swiper-button-next"></div>
        <div v-show="navigation" class="swiper-button-prev"></div>
      </div>
    </div>
  </div>

</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
  name: 'index',
  props: {
    // 上下翻页按钮
    navigation: {
      type: Boolean,
      default: false
    },
    // 分页按钮
    pagination: {
      type: Boolean,
      default: false
    },
    // 一组 N 个 默认 1 个
    slidesPerView: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    // const {
    //   home: {
    //     banner1
    //   }
    // } = this.$images
    return {
      swiper: null,
      swiperList: [
        // {
        //   id: 1,
        //   url: banner1
        // }, {
        //   id: 2,
        //   url: banner1
        // }
      ]
    }
  },
  watch: {
    list: {
      handler (vl) {
        this.swiperList = vl
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.getSwiper()
  },
  methods: {
    getSwiper () {
      this.swiper = new Swiper('.swiper-container', {
        loop: true, // 无缝
        autoplay: { // 自动开始
          delay: 5000, // 时间间隔
          disableOnInteraction: false //* 手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: this.slidesPerView, // 一组三个
        spaceBetween: 30, // 间隔
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
        observer: true,
        observeParents: true,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 分页器可以点击
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
  .banshi {
    width: 100%;
    margin: 0 auto;
  }

</style>
